// Libs
import React, { Component } from 'react'
import { Row, Col } from '../../components/Elemental'
import { NavLink } from 'react-router-dom'
import { connect } from 'react-redux'
import _ from 'lodash'

// CSS
import './styles.scss'

// Images
import arrowImage from '../../assets/arrow-3.svg'

// Contants
import { formatDate, exportAsXls } from '../../constants/others'

// Components/Containers
import Breadcrumb from '../../components/Breadcrumb'
import Label from '../../components/Label'
import Links from '../../components/Links'
import LoadingIcon from '../../components/LoadingIcon'

// Actions
import { changePaymentDateIndex, togglePaymentViewAll, fetchPaymentDates, fetchPaymentCases } from './actions'

class PaymentPage extends Component {
  UNSAFE_componentWillMount() {
    const { user: { groupId }, fetchPaymentDates } = this.props

    fetchPaymentDates(groupId)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { user: { groupId }, dateIndex, dates, fetchPaymentCases } = this.props
    const nextDateIndex = nextProps.dateIndex

    if (!_.isEmpty(dates) && dateIndex !== nextDateIndex) {
      if (nextDateIndex === 0) {
        const { start_date, end_date } = dates[nextDateIndex]

        const startDate = start_date.substring(0, 4) + start_date.substring(5, 7) + start_date.substring(8, 10)
        const endDate = end_date.substring(0, 4) + end_date.substring(5, 7) + end_date.substring(8, 10)

        fetchPaymentCases(null, groupId, startDate, endDate, true)
      } else {
        fetchPaymentCases(dates[nextDateIndex].id)
      }
    }
  }

  exportExtract = (data) => {
    let dataToExport = []
    let groupName = ''

    if (!_.isEmpty(data)) {
      groupName = data[0]
        .groupName
        .toLowerCase()
        .replace(' ', '_')
    }

    data.map(item => {
      const { id, lawsuitNumber, lawsuitUf, clientName, companyName, lawFirmName, createdAt, chargedAt, systemCode, maxValue1, provision, agreedValue } = item

      dataToExport = [
        ...dataToExport,
        {
          'Número do Caso': id,
          'Número do Processo': lawsuitNumber,
          'UF do Processo': lawsuitUf,
          'Parte': clientName,
          'Empresa': companyName,
          'Escritório Responsável': lawFirmName,
          'Data de Criação': formatDate(createdAt, false),
          'Data de Conclusão': formatDate(chargedAt, false),
          'Código do Sistema': systemCode,
          'Alçada': maxValue1,
          'Provisão': provision,
          'Valor Acordado': agreedValue
        }
      ]
    })

    exportAsXls(dataToExport, groupName ? `fatura-${groupName}` : 'fatura', 'Fatura')
  }

  render() {
    const { user, loading, cases, dateIndex, dates, viewAll, changePaymentDateIndex, togglePaymentViewAll } = this.props
    const { exportExtract } = this
    let paymentActionClassName = 'payment__action'
    let startDate = ''
    let endDate = ''

    if (!_.isEmpty(cases)) {
      paymentActionClassName = 'payment__action payment__action--allowed'
    }

    if (!_.isEmpty(dates)) {
      startDate = `${dates[dateIndex].start_date.substring(8, 10)}/${dates[dateIndex].start_date.substring(5, 7)}/${dates[dateIndex].start_date.substring(0, 4)}`
      endDate = `${dates[dateIndex].end_date.substring(8, 10)}/${dates[dateIndex].end_date.substring(5, 7)}/${dates[dateIndex].end_date.substring(0, 4)}`
    }

    return (
      <div className="payment">
        <div className="payment__header">
          <Breadcrumb routes={['perfil', 'pagamento']} />
          <Links options={[
            { 'to': '/perfil/alterar-informacoes', 'text': 'Alterar Informações' },
            { 'to': '/perfil/pagamento', 'text': 'Pagamento' }
          ]} />
        </div>
        <div className="payment__content">
          <Row>
            <Col md="25%">
              <Label gutterTop={0} gutterBottom={22.5}>Contagem Fatura (Casos)</Label>
              {!loading && !_.isEmpty(dates) &&
                <p>{cases.length}</p>
              }
            </Col>
            <Col md="25%">
              <Label gutterTop={0} gutterBottom={22.5}>Janela de Cobrança</Label>
              <div className="payment__window">
                {!loading && !_.isEmpty(dates) &&
                  <div>
                    <i className={dates[dateIndex + 1] === undefined ? "material-icons payment__arrow--disabled" : "material-icons"}
                      onClick={() => dates[dateIndex + 1] !== undefined && changePaymentDateIndex(dateIndex + 1)}>chevron_left</i>
                    <p>{`${startDate} até ${endDate}`}</p>
                    <i className={dates[dateIndex - 1] === undefined ? "material-icons payment__arrow--disabled" : "material-icons"}
                      onClick={() => dates[dateIndex - 1] !== undefined && changePaymentDateIndex(dateIndex - 1)}>chevron_right</i>
                  </div>
                }
              </div>
            </Col>
            <Col md="50%">
              <Label gutterTop={0} gutterBottom={22.5}>Status</Label>
              {!loading && !_.isEmpty(dates) &&
                <p>{dates[dateIndex]['is_new_receipt'] ? 'Em Andamento' : 'Fechada'}</p>
              }
              {!loading && _.isEmpty(dates) &&
                <p>Indefinida</p>
              }
            </Col>
          </Row>
          <Label gutterTop={42.5} gutterBottom={22.5}>Extrato Fatura</Label>
          <div className="payment__extract">
            <div className="payment__table-header">
              <p></p>
              <p>NÚMERO DO CASO</p>
              <p>NÚMERO DO PROCESSO</p>
              <p>ESCRITÓRIO RESPONSÁVEL</p>
              <p>DATA DE CRIAÇÃO</p>
              <p>DATA DE CONCLUSÃO</p>
              <p>CÓDIGO DO SISTEMA</p>
            </div>
            {!_.isEmpty(cases) && cases.map((item, idx) => {
              if (viewAll || (!viewAll && idx <= 4)) {
                return (
                  <div key={idx} className="payment__table-row">
                    <p>{idx + 1}</p>
                    <p><NavLink to={`/meus-casos/${item.id}`}>{item.id}</NavLink></p>
                    <p>{item.lawsuitNumber}</p>
                    <p>{item.lawFirmName}</p>
                    <p>{formatDate(item.createdAt, false)}</p>
                    <p>{formatDate(item.paymentPostponedTo ? item.paymentPostponedTo : item.chargedAt, false)}</p>
                    <p>{item.systemCode}</p>
                  </div>
                )
              }
              return
            })}
            {_.isEmpty(cases) &&
              <div className="payment__box">
                {!loading && !_.isEmpty(dates) &&
                  <p>O grupo {user.group} não possui nenhum caso concluido nesta janela de cobrança.</p>
                }
                {!loading && _.isEmpty(dates) &&
                  <p>O grupo {user.group} não possui uma janela de cobrança definida.</p>
                }
                {loading &&
                  <LoadingIcon type="grey" size={10} spaceBetweenDots={3} />
                }
              </div>
            }
            <div className="payment__actions">
              {cases.length > 5 &&
                <a className={paymentActionClassName} onClick={() => !_.isEmpty(cases) && togglePaymentViewAll()}>{viewAll ? 'Ocultar' : 'Exibir'} Todos</a>
              }
              {!_.isEmpty(cases) &&
                <a className={paymentActionClassName} onClick={() => !_.isEmpty(cases) && exportExtract(cases)}>Exportar</a>
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

PaymentPage = connect(state => {
  return {
    user: state.auth.user,
    loading: state.payment.loading,
    cases: state.payment.cases,
    dateIndex: state.payment.dateIndex,
    dates: state.payment.dates,
    viewAll: state.payment.viewAll
  }
}, { changePaymentDateIndex, togglePaymentViewAll, fetchPaymentDates, fetchPaymentCases })(PaymentPage)

export default PaymentPage
